import { render, staticRenderFns } from "./bannerAdd.vue?vue&type=template&id=1694cf82&scoped=true&"
import script from "./bannerAdd.vue?vue&type=script&lang=js&"
export * from "./bannerAdd.vue?vue&type=script&lang=js&"
import style0 from "./bannerAdd.vue?vue&type=style&index=0&id=1694cf82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694cf82",
  null
  
)

export default component.exports